import React, { Component } from 'react';
import * as d3 from "d3";
import numeral from "numeral";
import tooltip from "./Tooltip.js";
import utils from "./utils.js";
const customFormat = (value, format) => {
  if(typeof format === 'string'){
    return numeral(value).format(format)
  } else if (typeof format === 'function') {
    return format(value)
  }else{
    return value;
  }
}

export default class VerticalAreaChart extends Component {
  constructor(props) {
    super(props)

    
  }
  componentDidMount() {
    this.renderArea()
  }
  componentWillReceiveProps(nextProps){
    if((!typeof(nextProps.areaChartChildComponent)=='object') || (nextProps.areaChartChildComponent==null)){
      this.renderArea(nextProps)
    }
    
  }

  componentDidUpdate() {
  }
  componentWillUnmount(){
    hideDetail();    
  }

  renderArea(nextProps){
    var { yAxisScale,xAxisScale, margins, data, svgDimensions,xField,yField,fillColor,isGroupBar,groupIndex,curveStyle,
          type,yAxisData,dataLabels,marker,id,mainDivId,tooltip,name,showAreaChartTooltip,hideAreaChartTooltip,globalTooltip,globalTooltipData,tooltipStyle,tooltipPosition  } =nextProps || this.props;
    curveStyle=(curveStyle!=undefined || curveStyle!=null) ? curveStyle : 'curveLinear';
    const { height } = svgDimensions;
    var defaultDataLabelFormat=function(d){
      return d;
    };//"0,0.[00]"
    tooltipStyle.format= tooltipStyle.format!=undefined ? tooltipStyle.format : ((xAxisScale.labels && xAxisScale.labels.format) || defaultDataLabelFormat);
    tooltipStyle.prefix= tooltipStyle.prefix!=undefined ? tooltipStyle.prefix : ((xAxisScale.labels && xAxisScale.labels.prefix) || '');
    tooltipStyle.postfix= tooltipStyle.postfix!=undefined ? tooltipStyle.postfix : ((xAxisScale.labels && xAxisScale.labels.postfix) || '');
    var curveStyle = 'curveLinear';
    if(type=='verticalareaspline'){
        curveStyle = 'curveCardinal';
    }
    var area = d3.area()
    .curve(d3[curveStyle])
    .y(function(d) { 
        return yAxisScale.scale(d.yAxisValue)+(yAxisScale.scale.bandwidth()/2); 
    })
    .x0(margins.left)
    .x1(function(d) { 
        return xAxisScale.scale(d.xAxisValue);
     });

     var preparedData=[];
     yAxisData.forEach(function(d,index){
      d=(d!=null && typeof(d)=='object') ? d["data"]  :d;
       preparedData.push({
         yAxisValue:d,
         xAxisValue:data[index]
       });
     });
     if(typeof(fillColor)=='object'){
        var linearGradient=fillColor.linearGradient || [0,0,0,0];
        var stops=fillColor.stops ||  [
            [0, 'red'],
            [1, 'green']
          ]
        d3.selectAll('#AreaChartGradientColorContainer_'+this.props.id).append("linearGradient")
        .attr("id", "AreaChartGradientColor_"+this.props.id)
        .attr("gradientUnits", "userSpaceOnUse")
        .attr("y1", linearGradient[0]*svgDimensions.width/100).attr("x1", linearGradient[1]*svgDimensions.height/100)
        .attr("y2", linearGradient[2]*svgDimensions.width/100).attr("x2", linearGradient[3]*svgDimensions.height/100)
        .selectAll("stop")
        .data([
          {offset: "0%", color: stops[0][1]},
          {offset: "100%", color:stops[1][1]}
        ])
        .enter().append("stop")
        .attr("offset", function(d) { return d.offset; })
        .attr("stop-color", function(d) { return d.color; });
        fillColor="url(#AreaChartGradientColor_"+this.props.id;
     }
    

    d3.selectAll('#AreaChartContainer_'+this.props.id).selectAll("*").remove();
    d3.selectAll('#AreaChartContainer_'+this.props.id)
    .append("path")
    .data([preparedData])
    .attr("fill",fillColor)
    .style("fill-opacity",0.6)
    .attr("stroke",fillColor)
    .attr("stroke-width",2)
    .attr("class", "area")
    .attr("d", area);
     var that=this;
     //CBT:this is for data label
    
    //CBT:This is for marker
      var symbol=marker.symbol || 'circle';
      var fillColorMarker=(marker.fillColor==''?fillColor:marker.fillColor) ||fillColor;
      var radius=marker.radius || 0;
      if(symbol=='circle'){
        d3.selectAll("#AreaChartMarkerContainer_"+that.props.id).selectAll('*').remove();
        var markersCircle=d3.selectAll("#AreaChartMarkerContainer_"+that.props.id)
        .selectAll("circle")
        .data(preparedData).enter()
        .append('circle')
        .attr("data",function(d,index){
              var globalData={xAxisTooltipsLabel:d.xAxisValue,
                dataIndex:index,
                y:yAxisScale.scale(d.yAxisValue)+(yAxisScale.scale.bandwidth()/2),
                x:xAxisScale.scale(d.xAxisValue),
                r:radius
              }
              return JSON.stringify(globalData);
        })
        .attr('cy',function(d){
          return yAxisScale.scale(d.yAxisValue)+(yAxisScale.scale.bandwidth()/2)
        })
        .attr('cx',function(d){
          return xAxisScale.scale(d.xAxisValue)
        })
        .attr("r",function(d){
          return radius;
        })
        .style("stroke-width",function(d){
          return "4px";
        })
        .style("stroke",(marker.fillColor!=undefined && marker.fillColor !=null) ? fillColorMarker :'transparent')
        .style("fill",(marker.fillColor!=undefined && marker.fillColor !=null) ? fillColorMarker :'transparent')
        .style("stroke-opacity",0);
        //CBT:THis is for tooltips 
        if(tooltip==true || globalTooltip==true){
          markersCircle.on("mouseenter",null);
          markersCircle.on("mouseenter",(e)=>{
            d3.select(d3.event.target).transition().style("stroke-opacity",0.5);
            showDetail({id:mainDivId,margins:margins,tooltip:tooltip},[{[e.yAxisValue]:e.xAxisValue,name:name}],d3.event,globalTooltip,globalTooltipData,tooltipStyle,tooltipPosition);
          })
          if(tooltipPosition.toLowerCase()=='cursor'){
            markersCircle.on("mousemove",null);
            markersCircle.on("mousemove",(e,index)=>{
              showDetail({id:mainDivId,margins:margins,tooltip:tooltip},[{[e.yAxisValue]:e.xAxisValue,name:name}],d3.event,globalTooltip,globalTooltipData,tooltipStyle,tooltipPosition);
            });
          }
          markersCircle.on("mouseout",null);
          markersCircle.on("mouseout",function(d,mouseEvent){
            d3.select(d3.event.target).transition().style("stroke-opacity",0);
            hideDetail();
          });
        }else if(tooltip!=false && typeof(tooltip)=='object'){
            markersCircle.on("mouseenter",null);
            markersCircle.on("mouseenter",(e)=>{
              var cy=yAxisScale.scale(e.xAxisValue)+(yAxisScale.scale.bandwidth()/2);
              var cx=xAxisScale.scale(e.yAxisValue)
              showAreaChartTooltip(tooltip,{x:cx,y:cy,radius:radius,id:id,tooltipStyle:tooltipStyle}); 
            });
            markersCircle.on("mouseout",null);
            markersCircle.on("mouseout",function(d){
              hideAreaChartTooltip();
            });
          
        }
      }

      if(dataLabels!=undefined && dataLabels !=null && dataLabels.enabled==true){
      var format=dataLabels.format || (xAxisScale.labels && xAxisScale.labels.format) || defaultDataLabelFormat;
      var prefix=dataLabels.prefix || (xAxisScale.labels && xAxisScale.labels.prefix) || "";
      var postfix=dataLabels.postfix || (xAxisScale.labels && xAxisScale.labels.postfix) || "";
      d3.selectAll('#AreaChartLabelTextContainer_'+that.props.id).selectAll('*').remove();
      data.forEach(function(datum,index) {
        var xAxisLabels=(yAxisData[index]!=null && typeof(yAxisData[index])=='object') ? yAxisData[index]["data"]  :yAxisData[index];
        var style=$.extend({'dominant-baseline':'central'},false,(dataLabels && dataLabels.style ? dataLabels.style :{}));
          d3.selectAll('#AreaChartLabelTextContainer_'+that.props.id)
          .append('text')
          .attr("y",yAxisScale.scale(xAxisLabels)+(yAxisScale.scale.bandwidth()/2))
          .attr('x',xAxisScale.scale(datum)+radius)
          .style("fill",'#000')
          .attr('style',utils.convertReactStyleToHtml(style))
          .text(prefix+""+customFormat(datum,format)+""+postfix);
        })
      }
    
    
  }

  render() {
    const {  margins, data, svgDimensions} = this.props
    const { height } = svgDimensions;
    var that=this;

    return (
        <g>
        <g
        id={"AreaChartGradientColorContainer_"+this.props.id}
        transform={"translate(0,0)"}></g>
        <g
        className={'AreaChartContainer_'+this.props.id}
        id={"AreaChartContainer_"+this.props.id}
        transform={"translate(0,0)"}
        ref={(el) => { this.areaContainer = el; }}
        />
        <g
        id={"AreaChartLabelTextContainer_"+this.props.id}
          transform={"translate(0,0)"}>

        </g>
        <g
        id={"AreaChartMarkerContainer_"+this.props.id}
          transform={"translate(0,0)"}>

        </g>
        { React.Children.count(this.props.children) ? 
        <g className="areaChartChildComponent">
          { React.Children.map(this.props.children,function(child,index){
              return (<g key={index}  className="areaChartChildComponent">{child}</g>);
            })
          }
        </g> 
        : null
        }  
      </g>
    )
  }
}

export function showDetail(props, data, mouseEvent,globalTooltip,globalTooltipData,tooltipStyle,tooltipPosition) {
  var defaultValueFormat=function(d){
      return d;
    };
  var labelFontSize =tooltipStyle.labelFontSize ||  "12px";
  var labelFontColor =tooltipStyle.labelFontColor ||  "black";
  var labelFontFamily = tooltipStyle.labelFontFamily ||  "";
  var valueFontSize =tooltipStyle.valueFontSize ||  "12px";
  var valueFontColor =tooltipStyle.valueFontColor ||  "black";
  var valueFontFamily =tooltipStyle.valueFontFamily ||  "";
  if(props.tooltip===true){
    var globalData=JSON.parse(mouseEvent.target.getAttribute("data") || "{}");
    var format=tooltipStyle.format || defaultValueFormat;
    var prefix=tooltipStyle.prefix || '';
    var postfix=tooltipStyle.postfix || '';
    data.map(function(d) {
      var content = `<tr>
          <td colspan="2" class="value"  style="text-align: center;letter-spacing: 1.04px;line-height: 1.2;font-size:${valueFontSize};font-family:${valueFontFamily};color:${valueFontColor}">${
        d["name"]
      }</td></tr>`;
      delete d.name;
      var tooltipsContents = Object.keys(d);
      tooltipsContents.map(function(data) {
        content =
          content +
          `<tr><td class="key" style="letter-spacing: 1.04px;line-height: 1.2;font-size:${labelFontSize};font-family:${labelFontFamily};color:${labelFontColor}">${data} </td>
              <td class="value" style="letter-spacing: 1.04px;line-height: 1.2;font-size:${valueFontSize};font-family:${valueFontFamily};color:${valueFontColor}">${
                prefix+""+customFormat( d[data],format)+""+postfix
          }</td></tr>`;
      });
  
      d["content"] = content;
      d["x"] = (tooltipPosition=="cursor")? d3.event.x : globalData.x + $("#" + props.id).offset().left;//d3.event.x;
      d["y"] =(tooltipPosition=="cursor")? d3.event.y : globalData.y+ $("#" + props.id).offset().top;// d3.event.y;
      d["mainDivId"] = props.id;
      d["marginLeft"] = props.margins.left;
      d["marginTop"] = props.margins.top;
    });
    tooltip.showTooltip(data, d3.event, "tooltip_map",(tooltipPosition=="cursor") ?  true :false,globalTooltip);//,isMouseMove,isGlobalTooltip
  }else{
  }  
  
}

export function hideDetail(d) {
  tooltip.hideTooltip();
}